$(document).ready(function () {
    var AddEditGPModal  = $('#yr4StudentGPPlacementModal');
    var DeleteGPModal   = $('#deleteStudentGPPlacementmodal');
    var GPPlacementForm = $('#Yr4StudentGPPlacementForm');

    $(GPPlacementForm).validate({
        rules: {
            acyr: {
                required: true,
                digits: true,
            },
            block: {
                required: true,
                digits: true,
            },
            student_id: {
                required: true,
                digits: true,
            },
            practice_id: {
                required: true,
                digits: true,
            },
        },
        messages: {
            acyr: {
                required: 'Academic Year is required',
            },
            block: {
                required: 'Block is required',
            },
            student_id: {
                required: 'Please select a student',
            },
            practice_id: {
                required: 'Please select a GP practice for this student',
            },
        },
        submitHandler: function (form) {
            form.submit();
        },
    });

    $('.new-GPplacement').on('click', function () {
        AddEditGPModal.modal('show');
        var acyr     = $('ul.acyr-filter li.active').text().trim();
        var blocknum = $('ul.block-filter li.active').text().trim();
        AddEditGPModal.find('input[type=hidden][name="id"], select, textarea').val('').change();
        AddEditGPModal.find('input[type=checkbox]').prop('checked', false);
        $('select[name="practice_id"] .append').remove();
        $('input[type="hidden"][name="acyr"]').val(acyr);
        $('input[type="hidden"][name="block"]').val(blocknum);
        $('h4 span').text(' (' + acyr + ' Block ' + blocknum + ')');
    });

    $('.deleteGPplacement-btn').on('click', function () {
        DeleteGPModal.modal('show');
        var placement = $(this).parents('.placement-row').data('placement');
        $('p.acyr').empty().append('Academic Year: ' + placement.acyr);
        $('p.block').empty().append('Block: ' + placement.block);
        $('p.location').empty().append('Location: ' + placement.room + ' ' + placement.building);
        $('p.student').empty().append('Student name: ' + placement.studentname);
        $('input[type="hidden"][name="id"]').val(placement.placementid);
    });

    $('.editGPplacement-btn').on('click', function () {
        AddEditGPModal.modal('show');
        var placement = $(this).parents('.placement-row').data('placement');
        $('input[type="hidden"][name="id"]').val(placement.placementid);
        $('input[type="hidden"][name="acyr"]').val(placement.acyr);
        $('input[type="hidden"][name="block"]').val(placement.block);
        $('select[name="student_id"]').val(placement.studentid).change();
        $('select[name="practice_id"]').append('<option value="' + placement.locationid +  '" selected="selected" class="append">' + placement.building + '</option>');
        $('input[type="checkbox"][name="accommodation_required"][value="' + placement.accommodation_required + '"]').prop('checked', 'checked');
        $('input[type="checkbox"][name="car_required"][value="' + placement.car_required + '"]').prop('checked', true);
        $('input[type="checkbox"][name="has_car"][value="' + placement.has_car + '"]').prop('checked', true);
        $('textarea[name="notes"]').val(placement.notes);
    });

    $('.publish-placements').click(function () {
        $(this).prop('disabled', true).html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Publishing placements...');
    });

    // Count of all students with published placements
    var numpublished = $('.published .fa-circle').length;
    if (numpublished > 0) {
        $('span.countpublished').text('(' + numpublished + ' still unpublished)');
    }
});
